import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useGoalsQuery } from '@/hooks/goal-planner/queries/use-goals-query';

interface TaskGoalSelectorProps {
  goalId: string | null;
  onGoalChange: (value: string | null) => void;
}

const TaskGoalSelector: React.FC<TaskGoalSelectorProps> = ({
  goalId,
  onGoalChange
}) => {
  const { data: goals = [], isLoading } = useGoalsQuery();

  // Filter to only show active (non-completed) goals
  const activeGoals = goals.filter(goal => !goal.isCompleted);

  const handleGoalChange = (value: string) => {
    // Convert "none" back to null for the parent component
    onGoalChange(value === "none" ? null : value);
  };

  return (
    <div className="space-y-1">
      <Label htmlFor="goal">Project</Label>
      <Select value={goalId || 'none'} onValueChange={handleGoalChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select goal" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No Project</SelectItem>
          {isLoading ? (
            <SelectItem value="loading" disabled>Loading goals...</SelectItem>
          ) : (
            activeGoals.map(goal => (
              <SelectItem key={goal.id} value={goal.id}>
                {goal.projectTitle || goal.title}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TaskGoalSelector; 